export { DividerDecorative } from './DividerDecorative'
export type { DividerDecorativeProps } from './DividerDecorative'
